import React from 'react'
import { useAlerts } from '@theneatcompany/nui'
import { useFormContext, useWatch } from 'react-hook-form'

import { useSignUp } from '@/components/Providers/SignUpProvider'
import Form from '@/components/forms/Form'
import { Column, Box } from '@/components/layout'
import ControlledInputField from '@/components/forms/ControlledInputField'
import { Link, Button, Text } from '@/components/common'
import { UPSELL_COUPON, UPSELL_COUPON_DESCRIPTION } from '@/constants'

import styles from './Coupon.module.scss'

const RemoveCouponButton = () => {
  const { coupon, setCoupon } = useSignUp()
  const { setValue } = useFormContext()
  const removeCoupon = () => {
    setCoupon(null)
    setValue('promoCode', '')
  }

  return (
    <div className={styles.promoFriendlyDisplay} data-testid="applied-promo-code">
      {coupon?.isUpsell && coupon?.code === UPSELL_COUPON ? UPSELL_COUPON_DESCRIPTION : coupon?.name}
      <Button
        className={styles.removeCouponX}
        iconOnly
        iconProps={{ name: 'close', title: 'Remove', fill: 'dark-gray' }}
        onClick={removeCoupon}
        size="small"
        variant="default"
      >
        Remove Coupon
      </Button>
    </div>
  )
}

const ApplyCouponButton = () => {
  const promoCode = useWatch({ name: 'promoCode' })

  return (
    <Column shrink>
      <Form.Action
        className={styles.promoSubmit}
        data-testid="promo-code-apply-cta"
        disabled={!promoCode?.length}
        messageId="pages.signUp.form.billing.addCoupon"
        size="large"
        type="submit"
      />
    </Column>
  )
}

const couponError = <Text.P data-testid="promo-code-error">Coupon not found</Text.P>

const CouponForm = () => {
  const { coupon, setCoupon, fetchCoupon } = useSignUp()
  const alerts = useAlerts()

  const handleApplyCoupon = async (model) => {
    const { promoCode } = model
    const trimmed = typeof promoCode === 'string' ? promoCode.trim() : ''

    if (!trimmed) {
      alerts.error(couponError)
      return
    }

    try {
      await fetchCoupon(trimmed)
    } catch (err) {
      alerts.error(err.message)
      return
    }

    alerts.success('Coupon Added')
  }

  const removeCoupon = () => {
    setCoupon(null)
  }

  return (
    <Form
      enableReinitialize
      initialValues={{ promoCode: coupon?.code ?? '' }}
      onSubmit={handleApplyCoupon}
    >
      <div>
        {!coupon?.code &&
          <div>
            <Box gap={8}>
              <Column className={styles.promoInputCol} fill>
                <ControlledInputField
                  className={styles.promoInput}
                  data-testid="promo-code-input-field"
                  label="Promo Code"
                  labelProps={{ hidden: true }}
                  name="promoCode"
                  size="large"
                />
              </Column>
              <ApplyCouponButton />
            </Box>
          </div>}

        {coupon?.code &&
          <div className={styles.promoApplied}>
            <div className={styles.promoBox}>
              <div className={styles.promoAppliedText}>Promo Code Applied</div>
              <RemoveCouponButton />
            </div>
            <div className={styles.smallPrint}>Limit one promo code per order. <Link className={styles.smallPrintLink} onClick={removeCoupon} to="#">Apply a different code</Link></div>
          </div>}
      </div>
    </Form>

  )
}

export default CouponForm
